import { Hero } from "../components/home/Hero";
import { ProofBar } from "../components/home/ProofBar";
import { Services } from "../components/home/Services";
import { Differentiation } from "../components/home/Differentiation";
import { SendLink } from "../components/home/SendLink";
import { CaseStudy } from "../components/home/CaseStudy";
import { SinovarWay } from "../components/home/SinovarWay";
import { Trust } from "../components/home/Trust";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <ProofBar />
      <Services />
      <Differentiation />
      <SendLink />
      <SinovarWay />
      <CaseStudy />
      <Trust />
    </main>
  );
}
